module.exports = __webpack_public_path__ + "static/img/04.3905c8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/items/uvegtablak-falburkolatok/04.jpg
// module id = 633
// module chunks = 0